// Copyright (c) 2016 Deere & Company

export const create = (list, uniqueIdentifier) =>
    list.reduce((previous, current) => ({
        ...previous,
        [current[uniqueIdentifier]]: true
    }), {});



// WEBPACK FOOTER //
// ./src/shared/services/hashmap.js